import { render, staticRenderFns } from "./HbPlan.vue?vue&type=template&id=ace676fa&"
import script from "./HbPlan.vue?vue&type=script&lang=js&"
export * from "./HbPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports